import { getBaseApi } from "@/services/api";


const api = getBaseApi();

export const getWorkspace = async (id: string) => {
  const response = await api.get(`/workspaces/${id}`);
  return response.data?.data;
};

export const updateWorkspace = async (id: string, data: any) => {
  const response = await api.put(`/workspaces/${id}`, data);
  return response.data?.data;
};

export const getWorkspaceUsers = async (id: string, filter: { page: number, limit: number }) => {
  const response = await api.get(`/workspaces/${id}/users`, { params: filter });
  return response.data?.data;
};

export const updateWorkspaceUserRole = async (id: string, userId: string, data: { role: string }) => {
  const response = await api.patch(`/workspaces/${id}/users/${userId}/role`, data);
  return response.data?.data;
};

export const deleteWorkspaceUser = async (id: string, userId: string) => {
  const response = await api.delete(`/workspaces/${id}/users/${userId}`);
  return response.data?.data;
};

// Invitations
export const getWorkspaceInvitations = async (id: string, filter: { page: number, limit: number }) => {
  const response = await api.get(`/workspaces/${id}/invitations`, { params: filter });
  return response.data?.data;
};